import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHistory = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M4.925,14.522c-0.238,-0.798 -0.365,-1.646 -0.365,-2.522c0,-4.852 3.905,-8.787 8.722,-8.787c4.817,0 8.722,3.934 8.722,8.787c0,4.852 -3.905,8.787 -8.722,8.787c-2.297,0 -4.386,-0.894 -5.944,-2.356",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.282,8.083l0,4.474l4.006,2.491",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.493,12.373l3.365,2.924l3.364,-2.924",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		]
	})
});
export default SvgHistory;
